import { defineStore } from 'pinia';

// 新资金流放量开关
export const useBillSwitchStore = defineStore('billSwitch', {
  state: () => ({ switch: false }),
  actions: {
    setBillSwitch(billSwitch: boolean) {
      this.switch = billSwitch;
    },
  },
});
